import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=b31c60b6&scoped=true"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"
import style0 from "./Step5.vue?vue&type=style&index=0&id=b31c60b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31c60b6",
  null
  
)

export default component.exports